export const userPermissionNew = (item) => {
  let user = localStorage.getItem("user");
  user = user ? JSON.parse(user) : null;

  if (user?.menu_permissions?.includes(item)) {
    return true;
  }
  return false;
};
